import React from "react";
import { button, output, wrapper } from "./counter.css";
import { IconMinusCircle } from "../icons/icon-minus-circle";
import { IconPlusCircle } from "../icons//icon-plus-circle";

export function Counter({
  value = 0,
  onDecrementClick = () => {},
  onIncrementClick = () => {},
  min = 0,
  max = Infinity,
}) {
  return (
    <div className={wrapper}>
      <button
        type="button"
        onClick={() => onDecrementClick()}
        disabled={value <= min}
        className={button}
        aria-label="remover posição"
      >
        <IconMinusCircle width={16} height={16} />
      </button>
      <output className={output} data-testid={"output-counter"}>
        {value}
      </output>
      <button
        type="button"
        onClick={() => onIncrementClick()}
        disabled={value >= max}
        className={button}
        aria-label="adicionar posição"
      >
        <IconPlusCircle width={16} height={16} />
      </button>
    </div>
  );
}
